export default __webpack_public_path__ + "static/media/javascript.9bd7f2a1.svg";